import { createContext } from "react";
import { Optional } from "../../../types";
import { AutocompleteGroup, AutocompleteItem } from "../autocomplete.types";
import { type InputSize } from "../../../elements";

export const AutocompleteContext = createContext<{
  onChange?: Optional<(value?: Optional<AutocompleteItem<any>>) => void>;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItem?: Optional<AutocompleteItem>;
  variant?: Optional<"default" | "mobile">;
  filteredOptions: AutocompleteGroup[];
  value?: Optional<AutocompleteItem>;
  defaultOptions: AutocompleteItem[];
  onClose?: Optional<() => void>;
  onOpen?: Optional<() => void>;
  options: AutocompleteGroup[];
  hasResults: boolean;
  inputValue: string;
  close: () => void;
  isOpen: boolean;
  label: string;
  dataQA?: string;
  dataQaExtra?: string;
  size?: InputSize;
}>({
  setInputValue: () => {},
  setIsOpen: () => {},
  filteredOptions: [],
  defaultOptions: [],
  variant: "default",
  onChange: () => {},
  hasResults: false,
  close: () => {},
  inputValue: "",
  isOpen: false,
  options: [],
  label: "",
  dataQA: "",
  dataQaExtra: "",
  size: "medium",
});
